import type { WebapiEndpointBuilder } from '@/api/webapi.ts';

export type GetFixingReferencesBody = {
  tileId: string; // Unique identifier for the tile
  currencyPair: string; // e.g. "EURUSD"
  clientId: number; // Client ID for the request
};

export type GetFixingReferencesResponse = {
  FixingId: string; // 'WMR1PMLN';
  TimeStamp: string; // '2025-07-14T08:12:53.3757936+00:00';
  CurrencyPair: string; // 'EUR/USD';
  FixingHour: string; //'13:00';
  FixingPlace: string; // 'LN';
  MediaName: string; // 'RE';
}[];

export const getFixingReferences = (builder: WebapiEndpointBuilder) => {
  return builder.mutation<GetFixingReferencesResponse, GetFixingReferencesBody>({
    query: (body) => {
      return {
        url: '/ReferentialData/v2/FX/FixingReferences',
        method: 'GET',
        params: {
          currencyPair: body.currencyPair,
          counterpartyBdrId: body.clientId,
        },
      };
    },
  });
};
